module.exports = __webpack_public_path__ + "static/media/Slider1.7b4a7b35.png";